module.exports = __webpack_public_path__ + "img/personal_time2.81d2c3ce.png";